module.exports = __webpack_public_path__ + "static/media/iconSix.565c34e8.svg";